import type { ProductDetailDrawerProps } from '../types/components'
import { Info } from 'lucide-react'
import styles from '../styles/applicationDetail.module.css'


export function ProductDetailDrawer({
  productName,
  productDescription,
  onClose,
  testId = 'application-product-detail-panel',
  titleTestId = 'application-product-detail-panel-title',
  closeButtonTestId = 'application-product-detail-panel-close-button',
}: ProductDetailDrawerProps) {
  const name = productName?.trim() || '—'
  const description = productDescription ?? ''
  const descriptionIsHtml = /<\/?[a-z][\s\S]*>/i.test(description)

  return (
    <div className={styles.productDetailDrawer} data-testid={testId}>
      <div className={styles.productDetailDrawerHeader}>
        <div>
          <h3 className={styles.productDetailDrawerTitle} data-testid={titleTestId}>
            Product Details
          </h3>
        </div>
        <button
          type="button"
          className={styles.productDetailDrawerClose}
          data-testid={closeButtonTestId}
          onClick={onClose}
          aria-label="Close product details"
        >
          <i className="fa fa-times" aria-hidden />
        </button>
      </div>
      <div className={styles.productDetailDrawerBody}>
        <div className={styles.productDetailDrawerProductCard}>
          <span className={styles.productDetailDrawerProductIcon} aria-hidden>
            <Info className="h-5 w-5" strokeWidth={2.25} />
          </span>
          <div>
            <div className={styles.productDetailDrawerLabel}>Product</div>
            <div className={styles.productDetailDrawerName}>{name}</div>
          </div>
        </div>
        <div className={styles.productDetailDrawerSectionTitle}>Description</div>
        {description.trim() ? (
          <div
            className={`${styles.productDetailDrawerDescription} ${
              descriptionIsHtml ? styles.productDetailDrawerDescriptionHtml : ''
            }`}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        ) : (
          <div className={`${styles.productDetailDrawerDescription} ${styles.productDetailDrawerEmpty}`}>
            No product description available.
          </div>
        )}
      </div>
    </div>
  )
}
